import tinycolor from 'tinycolor2';

/* eslint-disable no-param-reassign */
export function target() {
  return (
    ['BannerWithMenu', 'Header'].includes(this.module) && this.data.colorOption
  );
}

export function migrate({ primaryColor }) {
  const bgColorProp =
    this.module === 'Header' ? 'backgroundColorMenu' : 'backgroundColor';
  const textColorProp =
    this.module === 'Header' ? 'menuTextColor' : 'textColor';

  if (this.data.colorOption === 'transparent') {
    this.data.opacity = 0;
    this.data[bgColorProp] = primaryColor;
    this.data[textColorProp] = '#FFFFFF';
  } else {
    this.data.opacity = 1;

    if (tinycolor(this.data[bgColorProp]).isDark()) {
      this.data[textColorProp] = '#FFFFFF';
    } else {
      this.data[textColorProp] = '#000000';
    }
  }

  delete this.data.colorOption;
}
